// src/components/SubmitGardenMapbox.tsx

import React from 'react';
import { Box, CircularProgress, Alert, Button } from '@mui/material';
import { useGardenEditor } from '../../hooks/useGardenEditor';
import { GardenMap } from './GardenMap';
import { GardenEditorUI } from './GardenEditorUI';

interface SubmitGardenMapboxProps {
    googlePlaceId: string;
    onExitAndRefresh: () => void;
    onCancel: () => void;
    isModerated?: boolean;
    isEditing: boolean;
}

const SubmitGardenMapbox: React.FC<SubmitGardenMapboxProps> = ({
    googlePlaceId,
    onExitAndRefresh,
    onCancel,
    isModerated = false,
    isEditing = false,
}) => {
    const { state, actions } = useGardenEditor(
        googlePlaceId,
        isModerated,
        isEditing,
        onExitAndRefresh,
        onCancel
    );

    if (state.isLoading) {
        return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}><CircularProgress /></Box>;
    }

    if (state.error && !state.isSubmitting) {
        return (
            <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 3 }}>
                <Alert severity="error" sx={{ mb: 2 }}>{state.error}</Alert>
                <Button variant="contained" onClick={onCancel}>Back to Pub</Button>
            </Box>
        );
    }
    
    return (
        <Box sx={{ height: '100%', width: '100%', position: 'relative' }}>
            <GardenMap
                viewState={state.viewState}
                pubName={state.pubName}
                features={state.features}
                drawRef={actions.drawRef}
                onDrawCreate={actions.modal.onDrawCreate}
                onDrawUpdate={actions.modal.onDrawUpdate}
                onMapClick={actions.modal.onPolygonClick}
                onActionable={actions.modal.onActionable}
                isDrawing={state.isDrawing}
            />
            <GardenEditorUI state={state} actions={actions} />
        </Box>
    );
};

export default SubmitGardenMapbox;